module.exports = __webpack_public_path__ + "static/media/location-dot-red.c71616d7.svg";